import {css, useTheme} from "@emotion/react";

import {Badge} from "@pg-design/badge-module";
import {CenteredImage} from "@pg-design/centered-image";
import {elevation} from "@pg-design/elevation";
import {borderRadius, calculateRemSize as crs, mr, onDesktop, p} from "@pg-design/helpers-css";
import {BrandLaurelIcon} from "@pg-design/icons-module";
import {Rating} from "@pg-design/rating";
import {Text} from "@pg-design/text-module";

import {useResponsiveLinkTarget} from "../../../../hooks/use_responsive_link_target";
import {useOfferLink} from "../../../../offer/detail/hooks/use_offer_link";
import {IOfferDetail} from "../../../../offer/types/IOfferDetail";
import {rankingBigViewBreakpoint} from "../../../constants/ranking_big_view_breakpoint";
import {RankingOfferData} from "../../RankingOfferData";

interface IProps {
    score: number;
    offer: Pick<IOfferDetail, "name" | "main_image" | "street_name" | "street_number" | "region" | "vendor" | "slug" | "id" | "groups">;
}

export function OfferRankingListItem(props: IProps) {
    const {score, offer} = props;
    const {name, main_image} = offer;
    const theme = useTheme();

    const target = useResponsiveLinkTarget();
    const offerLink = useOfferLink(offer);

    return (
        <li css={listItem}>
            <a href={offerLink} target={target} css={imageWrap}>
                <Badge
                    as="span"
                    icon={({fill, className}) => (
                        <BrandLaurelIcon css={[className, mr(1)]} fill={fill} wrapperColor={theme.colors.primary} wrapperSize="1.6" size="1.6" />
                    )}
                    css={badge}
                >
                    <Text variant="info_txt_2" css={badgeText}>
                        Wyróżnienie
                    </Text>
                </Badge>
                <CenteredImage
                    width={336}
                    height={180}
                    maxSourceWidth={336}
                    breakpoints={[
                        {mediaWidth: "0", width: "auto", height: "180px"},
                        {mediaWidth: rankingBigViewBreakpoint, width: "266px", height: "142px"}
                    ]}
                    alt={name}
                    src={main_image.m_img_440x440}
                />
            </a>
            <div css={itemContent}>
                <RankingOfferData offer={offer} css={offerData} />
                <Rating score={score} isReadOnly showScore />
            </div>
        </li>
    );
}

// Styles
const listItem = css`
    max-width: 360px;
    width: 100%;
    ${borderRadius(2)};
    background: white;
    display: flex;
    flex-direction: column;
    ${elevation(1)};
    overflow: hidden;

    @media screen and (min-width: ${rankingBigViewBreakpoint}) {
        max-width: none;
        flex-direction: row;
        width: 936px;
    }
`;

const badgeText = css`
    font-weight: 600;
`;

const imageWrap = css`
    position: relative;
`;

const badge = css`
    position: absolute;
    inset: ${crs(1)} auto auto ${crs(1)};
    z-index: 1;
`;

const itemContent = css`
    ${p(2)};
    gap: ${crs(2)};
    ${onDesktop(css`
        flex: 1;
        display: flex;
        flex-direction: column;
    `)}
`;

const offerData = css`
    ${onDesktop(css`
        flex: 1;
    `)}
`;
import {css, useTheme} from "@emotion/react";

import {Badge} from "@pg-design/badge-module";
import {CenteredImage} from "@pg-design/centered-image";
import {elevation} from "@pg-design/elevation";
import {borderRadius, calculateRemSize as crs, mr, onDesktop, p} from "@pg-design/helpers-css";
import {BrandLaurelIcon} from "@pg-design/icons-module";
import {Rating} from "@pg-design/rating";
import {Text} from "@pg-design/text-module";

import {useResponsiveLinkTarget} from "../../../../hooks/use_responsive_link_target";
import {useOfferLink} from "../../../../offer/detail/hooks/use_offer_link";
import {IOfferDetail} from "../../../../offer/types/IOfferDetail";
import {rankingBigViewBreakpoint} from "../../../constants/ranking_big_view_breakpoint";
import {RankingOfferData} from "../../RankingOfferData";

interface IProps {
    score: number;
    offer: Pick<IOfferDetail, "name" | "main_image" | "street_name" | "street_number" | "region" | "vendor" | "slug" | "id" | "groups">;
}

export function OfferRankingListItem(props: IProps) {
    const {score, offer} = props;
    const {name, main_image} = offer;
    const theme = useTheme();

    const target = useResponsiveLinkTarget();
    const offerLink = useOfferLink(offer);

    return (
        <li css={listItem}>
            <a href={offerLink} target={target} css={imageWrap}>
                <Badge
                    as="span"
                    icon={({fill, className}) => (
                        <BrandLaurelIcon css={[className, mr(1)]} fill={fill} wrapperColor={theme.colors.primary} wrapperSize="1.6" size="1.6" />
                    )}
                    css={badge}
                >
                    <Text variant="info_txt_2" css={badgeText}>
                        Wyróżnienie
                    </Text>
                </Badge>
                <CenteredImage
                    width={336}
                    height={180}
                    maxSourceWidth={336}
                    breakpoints={[
                        {mediaWidth: "0", width: "auto", height: "180px"},
                        {mediaWidth: rankingBigViewBreakpoint, width: "266px", height: "142px"}
                    ]}
                    alt={name}
                    src={main_image.m_img_440x440}
                />
            </a>
            <div css={itemContent}>
                <RankingOfferData offer={offer} css={offerData} />
                <Rating score={score} isReadOnly showScore />
            </div>
        </li>
    );
}

// Styles
const listItem = css`
    max-width: 360px;
    width: 100%;
    ${borderRadius(2)};
    background: white;
    display: flex;
    flex-direction: column;
    ${elevation(1)};
    overflow: hidden;

    @media screen and (min-width: ${rankingBigViewBreakpoint}) {
        max-width: none;
        flex-direction: row;
        width: 936px;
    }
`;

const badgeText = css`
    font-weight: 600;
`;

const imageWrap = css`
    position: relative;
`;

const badge = css`
    position: absolute;
    inset: ${crs(1)} auto auto ${crs(1)};
    z-index: 1;
`;

const itemContent = css`
    ${p(2)};
    gap: ${crs(2)};
    ${onDesktop(css`
        flex: 1;
        display: flex;
        flex-direction: column;
    `)}
`;

const offerData = css`
    ${onDesktop(css`
        flex: 1;
    `)}
`;
